// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","errorArea":"_24qO4Dy4DiGzW1VTxG9zdu","reportErrorButton":"_3n53BZ3XcfdhYnySa6BfwJ"};